import { getField, updateField } from 'vuex-map-fields';
import ProductCreationPage from './modules/ProductCreationPage';
import EditProductPage from './modules/EditProductPage';
import ShopPage from './modules/ShopPage';
import ProductDetailPage from './modules/ProductDetailPage';
import Cart from './modules/Cart';
import CustomerDashboard from './modules/CustomerDashboard';
import EditOrderPage from './modules/EditOrderPage';
import Stripe from './modules/Stripe';
import CustomerApplication from './modules/CustomerApplication';
import CheckoutPage from './modules/CheckoutPage';
import CreateOrderPage from './modules/CreateOrderPage';
import AdminDashboard from './modules/AdminDashboard';
import ProductCategoriesPage from './modules/ProductCategoriesPage';
import OrderListPage from "./modules/OrderListPage";
import CompanyEditPage from "./modules/CompanyEditPage";
import SiteNavBuilder from "./modules/SiteNavBuilder";
import Dropship from './modules/Dropship';

export default {
    modules: {
        ProductCreationPage,
        ShopPage,
        EditProductPage,
        ProductDetailPage,
        Cart,
        CustomerDashboard,
        EditOrderPage,
        Stripe,
        CustomerApplication,
        CheckoutPage,
        CreateOrderPage,
        ProductCategoriesPage,
        AdminDashboard,
        OrderListPage,
        CompanyEditPage,
        SiteNavBuilder,
        Dropship,
    },
    state: {
        site: {},
        user: {},
        show_activity_log_modal: false,
        activity_log_data: [],

        show_dialog: false,
    },
    getters: {
        getField,
        site(state) {
            return state.site
        },
        user(state) {
            return state.user
        }
    },
    mutations: {
        updateField,
        setSite(state, site) {
            state.site = site;
        },
        setUser(state, user) {
            state.user = user;
        }
    }
}